import { useReactiveVar } from "@apollo/client";
import { mdiLock } from "@mdi/js";
import Icon from "@mdi/react";
import React, { useContext } from "react";
import { currentSport } from "src/services/ApolloService";
import { SubscriptionContext } from "src/services/SubscriptionService";

const PremiumAccess = ({
  source,
  freeGame,
  scheduleItem,
  children,
  graybar = false,
}: {
  source: string;
  freeGame: boolean;
  scheduleItem: any;
  children: any;
  graybar?: boolean;
}) => {
  const ctx = useContext(SubscriptionContext);
  const currentSportObj = useReactiveVar(currentSport);
  const leagueName = currentSportObj?.name || "";
  const hasAccess = freeGame || ctx.hasSubscriptionAccess(currentSportObj?.key || "");

  if (!hasAccess) {
    return (
      <span
        onClick={() =>
          ctx.redirectToPricing(
            {
              screen: "GameView",
              page: "Game Detail",
              sport: leagueName,
              source: source,
              awayTeam: scheduleItem.awayTeam.fullName,
              homeTeam: scheduleItem.homeTeam.fullName,
              gameId: scheduleItem.id,
            },
            `Game Detail ${source}`
          )
        }
        className="schedule-list__table-item-5 schedule-list__table-cell schedule-list__table-cell-upgrade"
      >
        <div className="schedule-list__upgrade-con">
          <Icon path={mdiLock} size="16px" color="#004198" />
          {graybar ? (
            <div className="schedule-list__gray-bar" />
          ) : (
            <div className="schedule-list__upgrade-text">Premium Access</div>
          )}
        </div>
      </span>
    );
  }

  return children;
};

export default PremiumAccess;
